const formatPermissions = permissions =>
  typeof permissions === "string" ? [permissions] : permissions;

export default formatPermissions;
